export const displayProjectTypeMap = {
  all: 'All',
  extension: 'Extension',
  conversion: 'Conversion',
  'new build': 'New Build',
  renovation: 'Renovation',
  landscape: 'Landscape',
}